import {useAuth} from "../auth/Auth";
import ApolloClient from "apollo-boost";
import {useEffect, useState} from "react";

function useCustomApolloClient() {
    const [client, setClient] = useState(null)
    const auth = useAuth();
    const idToken = auth.getIdToken();

    useEffect(() => {
        console.log("creating client")
        const apolloClient = new ApolloClient({
            uri: process.env.NODE_ENV === 'development' ? 'http://localhost:9090/kgraphql' : '/kgraphql',
            headers: {
                Authorization: idToken ? `Bearer ${idToken}` : '',
            }
        });

        setClient(apolloClient)
    }, [])

    return client
}

export default useCustomApolloClient;